import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import i18next from 'i18next';
import { Button } from '@famly/mf_input_button';
import { Text } from '@famly/mf_data-display_text';
import { Stack } from '@famly/mf_layout_stack';
import { Box } from '@famly/mf_layout_box';
import { ModalHeader, ModalTopBar, ModalBody } from 'web-app/react/components/modals/modals';
import translate from 'signin-app/helpers/translate';
export const LogoutWarningModal = ({ onModalClose, onConfirm, siteName }) => {
    return (_jsxs(Box, { pb: 6, pt: 6, pr: 2, pl: 2, "data-e2e-id": "logout-warning-modal", children: [_jsxs(ModalTopBar, { onCloseModal: onModalClose, children: [_jsx(ModalHeader, { header: translate('logoutConfirmationTitle', {
                            siteName,
                        }) }), _jsx("div", {})] }), _jsx(ModalBody, { children: _jsx(Text, { variant: "body", mt: 4, children: translate('logoutConfirmationDescription', {
                        siteName,
                    }) }) }), _jsxs(Stack, { gap: 4, pr: 4, mt: 4, justifyContent: "flex-end", children: [_jsx(Button, { variant: "tertiary", text: i18next.t($ => $.cancel), onClick: onModalClose }), _jsx(Button, { variant: "primary", text: translate('logoutConfirmationButton'), onClick: onConfirm, "data-e2e-id": "confirm-logout-button" })] })] }));
};
